// Automatically generated in 'npm version' by scripts/genversion.js

'use strict'
const version = '5.2.3';
export default version;
